import _ from "lodash"

import { launchEmbeddedSignup } from "../../meta/embedded-signup";
import { useWhatsappOficial } from "../../../store/service-activation/useWhatsappOficial";

const POLL_MS = 5000

export class WhatsappOficialController {
  pollInterval = null

  constructor(props) {
    this.model = props.models.whatsappOficial

    _.bindAll(this, ["loadStatus", "loadUsage", "connect", "retrySync"])
  }

  loadStatus(options) {
    return this.model.getStatus(options)
  }

  loadUsage() {
    return this.model.getUsage()
  }

  retrySync() {
    return this.model.retrySync()
  }

  /**
   * Abre o Embedded Signup e manda o retorno pro backend.
   * Em coexistência o número não é registrado de novo — o backend pula esse passo.
   */
  async connect() {
    const actions = useWhatsappOficial.getState().actions
    actions.setStatus('connecting')

    try {
      const payload = await launchEmbeddedSignup()
      await this.model.onboard(payload)
      this.watchStatus()
    } catch (error) {
      console.error(error)
      actions.setAccount({
        status: 'disconnected',
        error: error?.message || null,
      })
    }
  }

  /** Enquanto estiver sincronizando, consulta o status até virar active. */
  watchStatus() {
    this.stopWatching()
    this.pollInterval = setInterval(async () => {
      const data = await this.model.getStatus({ silent: true })
      const status = data?.account?.status
      if (status === 'active' || status === 'error' || status === 'suspended') {
        this.stopWatching()
      }
    }, POLL_MS)

    return () => this.stopWatching()
  }

  stopWatching() {
    if (this.pollInterval) clearInterval(this.pollInterval)
    this.pollInterval = null
  }
}
